import './PairingEventRouteSegment.scss';
import CalendarReleaseCapsule from '../../CalendarReleaseCapsule/CalendarReleaseCapsule';
import { CALENDAR_TYPE, eventTransportationType } from '../../../constants/myBlockMonth';
import { getClassNameForEarlyOrLate } from '../../../pages/MyBlockMonth/myBlockMonthHelper';

const PairingRouteSegment = ({actualView, segment, pairingDetails, index, event, width}) => {  

    const getSegmentClassName = (index, deadhead, segmentsLength) => {
        let className = 'pairing__route__segment';
        className = deadhead ? `${className} ${className}--deadhead` : className;
        if(index === 0 && !event.carryIn) {
            if(index === segmentsLength-1 && !event.carryOut) return `${className} both`; 
            return `${className} first`; 
        }
        if(index === segmentsLength-1 && !event.carryOut) return `${className} last`;
        return className; 
    }

    return (
        <div className="c-pairing-route-segment" style={{width: `${segment.segmentLength/width*10000}%`}}>
            <div className="c-route-label" style={{paddingLeft: index === 0 ? `${pairingDetails.releaseWidth}px` : 0}}>
                {!(index === 0 && event.carryIn && !event.hasStartRelease) && segment.routes && (
                    <div id={`route__${event.unique_id}_${index}`} className="c-pairing-route-details">
                        {segment.routes.map((route, routesIndex) => {
                            return (
                                <span className={routesIndex % 2 === 0 || route === eventTransportationType.LIMO ? 'pairing__route__airport-code' : 'pairing__route__flt-no'}>
                                    {route}
                                </span>
                            )
                        })}
                    </div>
                )}
            </div>
            <div className={getSegmentClassName(index, segment.deadhead, pairingDetails.segments.length)}> 
                {segment.showRelease && (
                    <CalendarReleaseCapsule
                        calendarType={CALENDAR_TYPE.STANDARD}
                        pairingReleaseWidth={pairingDetails.releaseWidth} 
                    />
                )}
            </div>
            {pairingDetails.hasLayover && index === 0 && !event.carryIn && (
                <span 
                    id={`eventStartTime__${event.unique_id}`} 
                    className={getClassNameForEarlyOrLate(event.checkIn.deviation, actualView, 'pairing__time pairing__time--check-in')} 
                    style={{marginLeft: segment.showRelease ? pairingDetails.releaseWidth+'px' : 0}}
                >
                    {pairingDetails.startTime}
                </span>
            )}
            {pairingDetails.hasLayover && index === pairingDetails.segments.length-1 && !event.carryOut && (
                <span 
                    id={`eventEndTime__${event.unique_id}`} 
                    className={getClassNameForEarlyOrLate(event.checkOut.deviation, actualView, 'pairing__time pairing__time--check-out')}
                >
                    {pairingDetails.endTime}
                </span>
            )}
        </div>
    )
}

export default PairingRouteSegment;